
const liveSearchResults = document.querySelector('.searchwp-live-search-results');
if(liveSearchResults){
    liveSearchResults.setAttribute('aria-expanded', 'false');
}

